/**
 * TestRepositoryPage - Test Repository with Modern Layout
 *
 * Sub-tabs (Heat Profile, Test Repository, DCAL Generator, Coil Configurator), then list card and table.
 */

import React from 'react';
import TechnicalPageAgGrid from '../../components/CRCE Technical/TechnicalPageAgGrid';
import TechnicalSubTabs from './TechnicalSubTabs';
import './HeatProfilePage.css';
import './TestRepositoryPage.css';

const TestRepositoryPage = () => (
    <div className="test-repository-page heat-profile-page">
        <TechnicalSubTabs />
        <div className="test-repository-content-wrapper heat-profile-content-wrapper">
            <TechnicalPageAgGrid embeddedInModernLayout />
        </div>
    </div>
);

export default TestRepositoryPage;
